var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrillcutSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2661.63 488.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#592c82;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m330.55,311.99c41.06-35.82-34.08-192.65-159.5-255.71.11.33.22.69.33,1.02,7.22,19.58,12.02,37.82,14.57,54.87,3.44,21.25,4,45.17-2.71,70.83C163.34,261.81,86.84,314.87,0,380.99c193-120.83,299.47-41.88,330.55-69Zm-90.47-228.27c76.1,49.36,118.69,117.3,132.85,172.67-.72-135.42,85.41-212.42,131.6-256.39-61.48,25.32-145.13,119.64-264.44,83.72Zm120.99,261.15c-30.99,26.46-77.39,6.11-145.45-.59,72.08,12.44,143.32,57.51,228.79,143.98-38.11-67.71-58.56-126.91-66.92-178.84-2.01,15.51-7.54,27.87-16.43,35.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1200.79,369.18v-227.23h73.03v227.23h-73.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1320.56,369.18v-227.23h74.09v184.73h105.86v42.51h-179.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1543.85,369.18v-227.23h74.09v184.73h105.85v42.51h-179.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2002.01,183.66h-172.45v141.97h170.17l2.06,43.55h-167.37c-30.39,0-51.02-3.76-61.93-11.27-10.87-7.53-16.32-21.7-16.32-42.53v-119.9c0-20.66,5.37-34.73,16.17-42.27,10.77-7.49,31.46-11.26,62.08-11.26h167.37l.22,41.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2102.38,141.95v184.73h163.01v-184.73h74.07v173.43c0,20.66-5.5,34.78-16.51,42.39-11.03,7.61-31.95,11.4-62.78,11.4h-152.58c-30.61,0-51.32-3.76-62.09-11.27-10.79-7.53-16.17-21.7-16.17-42.53v-173.43h73.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2515.9,182.61v186.57h-73.38l.07-186.29h-79.22l.02-40.94h298.25v40.66h-145.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m474.31,369.18v-227.23h202.76c58.21,0,102.88,9.74,134.07,29.26,31.18,19.51,46.76,47.37,46.76,83.57,0,38.14-16.5,66.76-49.54,85.82-33.03,19.06-82.95,28.58-149.72,28.58h-184.33Zm74.08-42.51h94.61c51.69,0,87.85-5.69,108.51-17.06,20.62-11.37,30.94-30.52,30.94-57.48,0-23.43-8.59-40.88-25.73-52.33-17.18-11.47-43.47-17.2-78.95-17.2h-129.38v144.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1031.95,283.12h41.41c24.78,0,42.75-3.42,53.87-10.23,11.14-6.83,16.71-17.95,16.71-33.32v-53.54c0-15.56-5.57-26.82-16.71-33.73-11.12-6.9-29.09-10.35-53.87-10.35h-245.54c20.73,10.06,35.87,23.53,46.65,39.1h167.58c12.74,0,21.49,1.38,26.24,4.18,4.76,2.81,7.13,7.53,7.13,14.18v26.23c0,6.65-2.37,11.38-7.13,14.18-4.75,2.8-13.5,4.2-26.24,4.2h-145.35c1.47,12.94,1.58,26.12.74,39.1h39.61l132.82,86.06h105.36l-143.27-86.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrillcutSvg);
export default __webpack_public_path__ + "static/media/drillcut-SVG.05d0d67aa57b2eb512ed7f67dd91df75.svg";
export { ForwardRef as ReactComponent };